export default {
  isNumber(value) {
    const engValue = this.getEnglishNum(value);
    if (/^[0-9۰-۹,]*$/.test(engValue)) {
      return true;
    }
    return false;
  },
  isPositive(value) {
    const engValue = this.getEnglishNum(value);
    if (engValue >= 0) {
      return true;
    }
    return false;
  },
  isMobile(value) {
    const engValue = this.getEnglishNum(value);
    if (this.isNumber(engValue) && engValue.startsWith('09') && engValue.length === 11) {
      return true;
    }
    return false;
  },
  isPhone(value) {
    const engValue = this.getEnglishNum(value);
    if (this.isNumber(engValue) && engValue.startsWith('0') && engValue.length === 11) {
      return true;
    }

  },
   isPhoneStarter(value) {
    const engValue = this.getEnglishNum(value);
    if (this.isNumber(engValue) && engValue.startsWith('09')) {
      return true;
    }
  },
  isFarsi(value) {
    // remove space
    value = value.replace(/\s+/g, '');
    if (/^[آ-یء\s]+$/.test(value)) {
      return true;
    }
    return false;
  },
  isPassport(value) {
    const engValue = this.getEnglishNum(value);
    if (/^[A-Za-z][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]+$/.test(engValue)) {
      return true;
    }
    return false;
  },
  isEnglish(value) {
    // remove space
    value = value.replace(/\s+/g, '');
    if (/^[A-Za-z'-]+$/.test(value)) {
      return true;
    }
    return false;
  },
  isNationalCode(value) {
    const engValue = this.getEnglishNum(value);

    if (engValue && !/^\d{10}$/.test(engValue)) {
      return false;
    }
    else if (!engValue || /^\d{10}$/.test(engValue)) return true;
    const check = +engValue[9];
    const sum = Array(9).fill().map((_, i) => +engValue[i] * (10 - i)).reduce((x, y) => x + y) % 11;
    return (sum < 2 && check === sum) || (sum >= 2 && check + sum === 11);
  },
  isIdNumber(value) {
    const engValue = this.getEnglishNum(value);

    if (/^[0-9]+$/.test(engValue)) {
      return true;
    }
    return false;
  },
  isDecimalNumber(value) {
    const engValue = this.getEnglishNum(value);

    if (/^\d{0,3}$|\d\.\d{0,2}$/.test(engValue)) {
      return true;
    }
    return false;
  },
  isStrongPassword(value) {
    const engValue = this.getEnglishNum(value);

    if (/^(?=.*[A-Z])(?=.*\d)[A-Za-z!@\d]{7,}$/.test(engValue)) {
      return true;
    }
    return false;
  },
  getFarsiNum(str) {
    if (!str) {
      return str;
    };
    str = str.toString().replace(/0/g, '۰');
    str = str.toString().replace(/1/g, '۱');
    str = str.toString().replace(/2/g, '۲');
    str = str.toString().replace(/3/g, '۳');
    str = str.toString().replace(/4/g, '۴');
    str = str.toString().replace(/5/g, '۵');
    str = str.toString().replace(/6/g, '۶');
    str = str.toString().replace(/7/g, '۷');
    str = str.toString().replace(/8/g, '۸');
    str = str.toString().replace(/9/g, '۹');
    return str;
  },
  getEnglishNum(str) {
    if (!str) {
      return str;
    };
    str = str.toString().replace(/۰/g, '0');
    str = str.toString().replace(/۱/g, '1');
    str = str.toString().replace(/۲/g, '2');
    str = str.toString().replace(/۳/g, '3');
    str = str.toString().replace(/۴/g, '4');
    str = str.toString().replace(/۵/g, '5');
    str = str.toString().replace(/۶/g, '6');
    str = str.toString().replace(/۷/g, '7');
    str = str.toString().replace(/۸/g, '8');
    str = str.toString().replace(/۹/g, '9');

    str = str.toString().replace(/٠/g, '0');
    str = str.toString().replace(/١/g, '1');
    str = str.toString().replace(/٢/g, '2');
    str = str.toString().replace(/٣/g, '3');
    str = str.toString().replace(/٤/g, '4');
    str = str.toString().replace(/٥/g, '5');
    str = str.toString().replace(/٦/g, '6');
    str = str.toString().replace(/٧/g, '7');
    str = str.toString().replace(/٨/g, '8');
    str = str.toString().replace(/٩/g, '9');
    return str;
  },
  isPostalCode(value) {
    const toEngNumber = this.getEnglishNum(value);
    if (/^.........[0-9]+$/.test(toEngNumber)) {
      return true;
    }
    return false;
  },
  currencyFormat(val, locale) {
    if (val < 0) {
      return;
    }
    val = val.toString();
    // eslint-disable-next-line
    val = val.replace(/,/g, "").replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ",");

    if (locale === 'en') {
      return val;
    } else {
      return this.getFarsiNum(val);
    }
  },
  currencyDeformat(val) {
    if (!val) {
      return;
    }
    return val.split(',').join('');
  },
  isUserName(value) {
    const engValue = this.getEnglishNum(value);
    let regUser = (/^[a-zA-Z0-9](_(?!(\.|_))|\.(?!(_|\.))|[a-zA-Z0-9]){3,18}[a-zA-Z0-9]$/);
    if (!regUser.test(engValue)) {
      return false;
    }
    return true;
  }
};
